<template>
    <el-dialog :title="statusTitle" :visible.sync="statusOpen" width="80%" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="70px">
        <el-form-item label="驳回原因" prop="rejectMessage" v-if="statusTitle == '驳回'">
          <el-input v-model="form.rejectMessage" placeholder="请输入驳回原因" />
        </el-form-item>
        <el-form-item label="延期原因" prop="extensionMessage" v-if="statusTitle == '延期'">
          <el-input v-model="form.extensionMessage" placeholder="请输入延期原因" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitStatus">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
</template>

<script>
import {  updateStatus } from '@/api/workOrder';
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      statusTitle: '',
    statusOpen: false,
       // 表单参数
       form: {},
      // 表单校验
      rules: {
      },
      statusType: ''
    }
  },
  methods: {
    showForm(type,record,statusTitle){
      this.statusOpen = true
      this.statusType = type
      this.form = record
      this.statusTitle = statusTitle
    },
        // 取消按钮
        cancel() {
      this.statusOpen = false;
    },
    submitStatus() {
      const data = {}
      data.id = this.form.id
      data.status = this.statusType
      data.userId = Cookies.get("userId")
      data.userName = Cookies.get("NickName")
      data.rejectMessage = this.form.rejectMessage
      data.extensionMessage = this.form.extensionMessage
      data.realStartTime = this.form.realStartTime
      data.realEndTime = this.form.realEndTime
      updateStatus(data).then(response => {
        this.$message({
          message: '修改成功',
          type: 'success'
        });
        this.statusOpen = false;
        this.$emit('ok')
      });
    },
  },
  mounted() {
  
  }
}
</script>

<style scoped>

</style>
